import { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { Send, Bot, ShieldCheck } from "lucide-react";
import { streamSSE } from "@/lib/api";
import Md from "@/components/Md";
import { PageHeader, Btn } from "@/components/kit";

const SUGGEST = ["How many Personal Loan leads are pending KYC?", "Which employees have the highest pending follow-ups?", "How many applications were disbursed this month?",
  "Which lender has the highest application count?", "Show today's follow-ups.", "Find leads where salary is above ₹50,000 and KYC is pending."];

export default function AIAssistant() {
  const [msgs, setMsgs] = useState([]);
  const [q, setQ] = useState("");
  const [sid, setSid] = useState(null);
  const [busy, setBusy] = useState(false);
  const end = useRef(null);
  useEffect(() => end.current?.scrollIntoView({ behavior: "smooth" }), [msgs]);
  const ask = async (text) => {
    const t = (text || q).trim();
    if (!t || busy) return;
    setQ("");
    setBusy(true);
    setMsgs((m) => [...m, { role: "user", content: t }, { role: "assistant", content: "" }]);
    try {
      const r = await streamSSE("/ai/chat", { message: t, session_id: sid }, (d) => setMsgs((m) => { const c = [...m]; c[c.length - 1] = { ...c[c.length - 1], content: c[c.length - 1].content + d }; return c; }));
      if (r.sessionId) setSid(r.sessionId);
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };
  return (
    <div className="mx-auto flex h-full max-w-4xl flex-col">
      <PageHeader title="FinOrbit Copilot" subtitle="AI MIS & CRM assistant. Answers only from data your role is authorised to see." />
      <div className="mb-3 flex items-center gap-2 rounded-lg bg-emerald-50 px-3 py-2 text-xs text-emerald-800"><ShieldCheck className="h-4 w-4" />Assistive only: never makes lending decisions, guarantees approval, or changes rules.</div>
      <div className="flex-1 space-y-4 overflow-y-auto rounded-xl border border-slate-200 bg-white p-4" style={{ minHeight: 360 }} data-testid="ai-chat-messages">
        {msgs.length === 0 && <div className="grid gap-2 sm:grid-cols-2">{SUGGEST.map((s) => <button key={s} onClick={() => ask(s)} data-testid="ai-suggestion" className="rounded-lg border border-slate-200 p-3 text-left text-sm hover:border-blue-300 hover:bg-blue-50/40">{s}</button>)}</div>}
        {msgs.map((m, i) => (
          <div key={i} className={`flex gap-3 ${m.role === "user" ? "justify-end" : ""}`}>
            {m.role === "assistant" && <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-900 text-white"><Bot className="h-4 w-4" /></div>}
            <div data-testid={`ai-msg-${m.role}`} className={`max-w-[85%] rounded-xl px-4 py-2.5 text-sm ${m.role === "user" ? "bg-blue-900 text-white" : "prose-ai bg-slate-50 text-slate-800"}`}>
              {m.role === "assistant" ? (m.content ? <Md text={m.content} /> : <span className="animate-pulse text-slate-400">Thinking…</span>) : m.content}
            </div>
          </div>
        ))}
        <div ref={end} />
      </div>
      <div className="mt-3 flex gap-2">
        <input data-testid="ai-chat-input" className="fo-input" placeholder="Ask about leads, follow-ups, disbursements…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ask()} />
        <Btn data-testid="ai-chat-send" loading={busy} onClick={() => ask()}><Send className="h-4 w-4" /></Btn>
      </div>
    </div>
  );
}
